export const DEFAULT_IMAGE_URL="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Anonymous.svg/200px-Anonymous.svg.png"

export const USER_DATA_TTL_HOURS = 168; // 7 days